import { Component, useRef } from 'react';
import { Accordion, Grid, Icon, Segment } from 'semantic-ui-react';
import { useWikiSearch } from '../WikiSearchContext';
import useHighlightMatches from '../useHighlightMatches';

class EmployeeHandbookClass extends Component {
  state = {
    activeIndex: [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    ],
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;

    const newIndex = activeIndex.includes(index)
      ? activeIndex.filter((i) => i !== index)
      : [...activeIndex, index];

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;
    const { contentRef } = this.props;

    return (
      <div ref={contentRef}>
        <Grid id="detailed-segment">
          <Grid.Column width={16}>
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Accordion styled fluid id="segment" exclusive={false}>
                  <Accordion.Title
                    active={activeIndex.includes(0)}
                    index={0}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Welcome to React
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(0)}>
                    <h5>Preface</h5>
                    <p id="orange">
                      Towards the end of 2018, we set out to create an agency
                      that would advance behavioral health and provide the
                      greatest level of care for those with Autism and other
                      special needs. Before this could happen, we knew that we
                      had to first create a foundation that was designed to
                      foster that greatness in every single team member. A place
                      where passionate individuals are empowered to put their
                      best work forward in order to make a meaningful impact on
                      those who need our services.
                    </p>
                    <p id="orange">
                      This wiki/handbook is an abbreviated encapsulation of our
                      guiding principles. As React continues to grow, we hope
                      that these principles will serve each new person joining
                      our team. If you are new to React, welcome. Although the
                      goals in this book are important, it’s really your ideas,
                      talent, and energy that will keep React shining in the
                      years ahead.
                    </p>
                    <p id="orange">
                      Thanks for being here. Let’s make great things happen.
                    </p>

                    <h5>Welcome to React</h5>
                    <p id="orange">
                      This handbook for new employees was written to give you
                      the answers to the most often asked questions about
                      policies, workflows, what we expect from you and what you
                      may expect from us. We believe the more you learn about
                      the company and its mission - the better employee you will
                      be. We also believe our success depends on our employees’
                      knowledge, skills and commitment to providing the greatest
                      possible client support.
                    </p>
                    <p id="orange">
                      React was founded with the goal of not just being another
                      behavioral health agency. Because of this, we expect more
                      out of each and every team member. So if you’re reading
                      this, we have selected you because we see something
                      special. We are also pleased that you have decided to join
                      our team and we look forward to making great things
                      happen.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(1)}
                    index={1}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Disclaimer
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(1)}>
                    <blockquote id="orange">
                      This React Behavioral Health, (hereinafter referred to as
                      ("React Behavioral Health”, “React” or "the Company")
                      Employee Handbook establishes policies, procedures,
                      benefits, and working conditions that will be followed by
                      all React employees as a condition of their employment at
                      the Company. The Standards of Conduct describe the
                      expected actions and behaviors of employees while
                      conducting Company business.
                    </blockquote>
                    <blockquote id="orange">
                      This React Employee Handbook is not a contract of
                      employment nor is it intended to create contractual
                      obligations for the Company of any kind. The policies and
                      procedures outlined in this handbook will be applied at
                      the discretion of React Behavioral Health. React reserves
                      the right to deviate from the policies, procedures,
                      benefits, and working conditions described in this
                      handbook.
                    </blockquote>

                    <blockquote id="orange">
                      Furthermore, the Company reserves the right to withdraw or
                      change the policies, procedures, benefits, and working
                      conditions described in this handbook at any time, for any
                      reason, and without prior notice. The Company will make
                      every effort to notify employees when an official change
                      in policy or procedure has been made but employees are
                      responsible for their own up-to-date knowledge about
                      Company policies, procedures, benefits, and working
                      conditions.
                    </blockquote>

                    <blockquote id="orange">
                      No provision in this employee handbook and expected
                      Standards of Conduct can be waived without written
                      permission from the Company’s CEO, or designee. Such a
                      waiver, if granted, applies only to the employee for whom
                      the waiver was granted at the time of the waiver.
                    </blockquote>

                    <blockquote id="orange">
                      React strives to provide an employee-friendly environment
                      in which goal-oriented individuals thrive as they achieve
                      ever more demanding challenges. These policies, procedures
                      and working conditions provide a work environment in which
                      both client interests and employee interests are served.
                    </blockquote>

                    <blockquote id="orange">
                      React values the talents and abilities of our employees
                      and seeks to foster an open, cooperative, and dynamic
                      environment in which employees and the Company alike can
                      thrive. The Company provides an Open Door Policy in which
                      employees are encouraged to take problems to the next
                      level of management if they are unable to resolve a
                      situation with their direct supervisor.
                    </blockquote>

                    <blockquote id="orange">
                      React is an equal opportunity employer. Religion, age,
                      gender, national origin, sexual orientation, race, or
                      color does not affect hiring, promotion, development
                      opportunities, pay, or benefits. React provides for fair
                      treatment of employees based on merit. The company
                      complies with all applicable Federal, state, and local
                      labor laws. Employment at React is on an “at will” basis,
                      which means that either you, the employee or React, may
                      terminate the employment relationship at any time, for any
                      reason, with or without cause. Only a written agreement,
                      signed by the CEO of React, can change the “at will”
                      nature of the employment of any individual.
                    </blockquote>
                    <blockquote id="orange">
                      Please review the policies, procedures, working
                      conditions, and benefits described in this handbook. You
                      will be asked to affirm that you have read, understand,
                      agree to abide by, and acknowledge your receipt of this
                      employee handbook and Employee Standards of Conduct.
                    </blockquote>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(2)}
                    index={2}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Our Vision of Service and Goals
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(2)}>
                    <h5>
                      React's mission is to advance behavioral health in order
                      to provide the greatest level of care for those with
                      Autism and other special needs.
                    </h5>
                    <ol id="blue">
                      <li>Support the abilities of all individuals</li>
                      <li>
                        Create an environment where all communication is valued
                      </li>
                      <li>
                        Respect all individuals & help people build off of their
                        strengths
                      </li>
                      <li>Continually look for ways to improve</li>
                      <li>Operate as efficiently as possible</li>
                      <li>
                        Use scientifically based research to guide our services
                      </li>
                      <li>
                        Create an environment of continued learning and training
                      </li>
                      <li>Give back to the communities that support us</li>
                      <li>Support other providers in our field</li>
                    </ol>
                    <h5>Our Vision of Service</h5>
                    <p id="orange">
                      Our services will begin through onboarding, which will be
                      led by David Hansen, our Program Development Director.
                      David has experience on-boarding new clients in this field
                      and aims to establish a rapport with families, determining
                      their strengths and needs and then coordinating which BHPs
                      would be the most beneficial to that clients progression.
                      During this time, he will conduct any needed assessments
                      and gather information to create an Individualized
                      Treatment Plan, as well as discuss our approach and vision
                      for services with that family.
                    </p>
                    <p id="orange">
                      After the initial onboarding, we will then determine which
                      Program Manager and BHP would be the best fit. Our Program
                      Manager and BHP will then familiarize themselves with that
                      clients background information and needs before having a
                      meet and greet with the family. Our BHPs will have access
                      to more comprehensive trainings and techniques before and
                      after they begin serving clients. We will require BHPs to
                      complete Module 1 of the BHP Certification course within
                      30 days of being hired. We believe all employees benefit
                      greatly from trainings and being BHP Certified, so BHPs
                      are encouraged to complete their BHP Certification within
                      3 to 6 months. They will be given up to a year to do so.
                    </p>
                    <p id="orange">
                      Our software application, the react-portal, will be used
                      to document each Session our BHPs work with a client. This
                      will enable the entire team to stay connected to how each
                      Session is going and also offer that BHP the opportunity
                      to reach out for guidance and help. This will make
                      documentation much more usable and accessible for
                      everyone. The react-portal will also be used for
                      Supervisions, Individual Treatment Plans (ITPs),
                      Timecards, tracking available client hours, and much more.
                      The react-portal is constantly being updated so let us
                      know if you have any ideas or suggestions.
                    </p>
                    <h5>Company Overall Goals</h5>
                    <b id="orange">Company Commitment to Employees</b>
                    <blockquote id="orange">
                      Our goal is to be the best agency to work for in Maine. We
                      aim to be the closest knit, most open and highest
                      rewarding agency. We will also do everything we can to
                      streamline your workflow so you can focus on providing the
                      best possible support. We ask for continual feedback as to
                      how we may improve.
                    </blockquote>

                    <b id="orange">Code of Conduct and Business Ethics</b>
                    <blockquote id="orange">
                      Everything we do in connection with our work at React will
                      be measured against the highest possible standards of
                      ethical business conduct.
                    </blockquote>

                    <b id="orange">Non-solicitation Policy</b>
                    <blockquote id="orange">
                      React prohibits the solicitation, distribution and posting
                      of materials on or at Company property by any employee or
                      non-employee, except as may be permitted by this policy.
                      The sole exceptions to this policy are charitable and
                      community activities supported by Company management and
                      Company-sponsored programs related to Company services.
                      Solicitation from a client, client’s family, vendors and
                      customers by an employee of money, gifts, loans, etc are
                      not permitted.
                    </blockquote>

                    <b id="orange">
                      Employee and Employer Confidentiality Agreement
                    </b>
                    <blockquote id="orange">
                      The Company will maintain the confidentiality of
                      “protected health information” or “PHI” as defined by the
                      Health Insurance Portability and Accountability Act of
                      1996 (HIPAA). The Company will also maintain the
                      confidentiality of other information that is deemed to be
                      confidential by other laws. This information may include
                      but is not limited to, information on clients, employees,
                      financial and business operations. Confidential
                      information may include but is not limited to, written,
                      electronic, oral, overheard or observed. Access to all
                      information is granted on a need to know basis which is
                      information that is required to complete your job
                      requirements. Confidential information should not be
                      discussed with anyone including but not limited to,
                      clients, co-workers, other families, your family or your
                      friends. You must not discuss confidential information in
                      an environment where others may overhear. Disclosure of
                      confidential information is grounds for disciplinary
                      action up to and including termination. Any and all
                      records must be returned to the Company upon termination
                      of your employment.
                    </blockquote>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(3)}
                    index={3}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    General Employment Information
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(3)}>
                    <h5>Equal Employment Opportunity Policy</h5>
                    <p id="orange">
                      An equal and open employment system has been established
                      and will be maintained. It is the policy of the Company to
                      hire all personnel without regard to race, religion,
                      color, sex, age, disability or national origin. The
                      Company complies with specifications of Title VII of the
                      Civil Rights Act of 1964, the Rehabilitation Act of 1973,
                      the Age Discrimination in Employment of 1967, the
                      Pregnancy Discrimination Act of 1978 and the Equal Pay Act
                      of 1963.
                    </p>
                    <h5>Employment Eligibility</h5>
                    <p id="orange">
                      Our companies, procedures and practices are designed to
                      prohibit discrimination on the basis of race, color,
                      religion, disability, ancestry, national origin, age, or
                      sex. Employment opportunities shall be provided for
                      applicants with disabilities and reasonable accommodations
                      shall be made to meet the physical and mental limitations
                      of qualified applicants or employees.
                    </p>
                    <h5>Internal Employee Application Process</h5>
                    <p id="orange">
                      The Company may need to fill positions which may have
                      minimum requirements. The Company will advertise
                      internally for such positions as well as externally. A
                      resume and cover letter explaining why they would be the
                      best fit for such position may be required. Qualified
                      applicants will be interviewed and the best qualified
                      applicants will be selected.
                    </p>
                    <h5>Promotions</h5>
                    <p id="orange">
                      React aims to promote internally whenever possible
                      although all promotions will be based on the
                      qualifications of the applicant. Factors for promotions
                      include experience, training, ability, personality, as
                      well as knowledge and expertise for the available
                      position.
                    </p>
                    <h5>Open Door Policy</h5>
                    <p id="orange">
                      React has an Open Door Policy. This means that if you
                      should have a concern, you do not necessarily need to go
                      through your immediate supervisor.
                    </p>
                    <h5>Personnel File Policy</h5>
                    <p id="orange">
                      React employee files are maintained by the Company and are
                      considered confidential. Managers only have access to
                      personnel file information on a need-to-know basis. A
                      manager considering the hire of a former employee or the
                      transfer of a current employee may be granted access to
                      the file, or limited parts of it, in accordance with
                      anti-discrimination laws. Personnel files may not be taken
                      outside of the Company premises or network.
                      Representatives of government or law enforcement agencies,
                      may be allowed access to file information. This decision
                      will be made at the discretion of React in response to the
                      employee’s request, a valid subpoena or a valid court
                      order.
                    </p>
                    <h5>Access to Personnel Records</h5>
                    <p id="orange">
                      Personnel file access by current and former employees will
                      be permitted in accordance with Title 26, Section 631 of
                      Maine state law.
                    </p>
                    <h5>Harassment & Discrimination</h5>
                    <p id="orange">
                      Types of Harassment & Disciplinary Action:
                    </p>
                    <ol id="blue">
                      <li>
                        Sexual Harassment: Unlawful sexual harassment is when
                        and includes:
                      </li>
                      <ul>
                        <li>
                          Job benefits are granted on an employee’s agreement to
                          sexual demands or advances.
                        </li>
                        <li>
                          Job benefits are withheld based on an employee’s
                          refusal to agree to sexual advances or demands.
                        </li>
                        <li>
                          The working environment is oppressive to employees of
                          one sex
                        </li>
                        <li>
                          Threats that an employee’s refusal to sexual advances
                          will adversely affect the employee’s conditions of
                          employment or career
                        </li>
                        <li>
                          Sexual relations that an employee does not want which
                          include unnecessary touching, patting, pinching,
                          brushing against or physical assault
                        </li>
                        Verbal harassment of a sexual nature which include
                        degrading comments, propositions, offensive or unwelcome
                        sexual flirtations, jokes or remarks about another
                        person’s clothing, body, appearance or sexual activities
                      </ul>
                      <li>
                        Other Harassment: Other unlawful harassment includes
                        derogatory remarks, slurs or actions targeting an
                        employee’s age, race, national origin, color, religion,
                        disability, sexual orientation or gender orientation.
                      </li>
                      <li>
                        Reporting Harassment: If an employee believes they have
                        encountered harassment from another employee,
                        supervisor, or other - that employee should report the
                        harassment immediately to a supervisor, member to
                        management or HR. After an investigation and review a
                        determination will be made as to whether the claim has
                        been substantiated.
                      </li>
                      <li>
                        Discipline for Harassment: If the claim has been
                        substantiated, the Company will take appropriate action
                        which may include termination.
                      </li>
                    </ol>
                    <p>
                      <i>
                        Harassment in any form is prohibited and may result in
                        disciplinary action up to and including termination.
                      </i>
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(4)}
                    index={4}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Attendance at Work
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(4)}>
                    <h5>Exempt and Non-exempt Employee Definitions</h5>
                    <ul id="blue">
                      <li>
                        Exempt and Non-Exempt positions are based upon job
                        responsibility and in accordance with the Fair Labor
                        Standards Act.
                      </li>
                      <li>
                        Exempt: Employees excluded from the overtime provisions
                        of the Fair Labor Standards Act.
                      </li>
                      <li>
                        Non-Exempt: Positions eligible for overtime pay if more
                        than 40 hours are worked in a workweek.
                      </li>
                    </ul>
                    <h5>Working Hours & Overtime</h5>
                    <p id="orange">
                      Probationary Period: Newly hired, rehired or promoted
                      employees are considered probationary until the completion
                      of ninety (90) calendar days of employment.
                    </p>
                    <ul id="blue">
                      <li>
                        Regular - Full Time: A regular scheduled full time
                        employee is employed on a regular basis on a schedule of
                        40 hours a week.
                      </li>
                      <li>
                        Regular - Part Time: A regular schedule part time
                        employee is scheduled for thirty-nine (39) or less hours
                        a week.
                      </li>
                      <li>
                        Temporary: A temporary employee is one who is employed
                        for a defined and/or limited period of time and is so
                        informed at the time of hire.
                      </li>
                      <li>
                        As Needed: An employee who is scheduled to work only as
                        needed.
                      </li>
                    </ul>

                    <h5>Good Standing Definition</h5>
                    <p id="orange">
                      An employee is considered in "good standing" if:
                    </p>
                    <ul id="blue">
                      <li>
                        All notes have been completed with accurate and detailed
                        prompts, notes, and signatures. All notes must be
                        completed within 2 days of the shift.
                      </li>
                      <li>
                        You are meeting regularly with your Program Manager for
                        supervision.
                      </li>
                      <li>You have not had any unexcused absences.</li>
                      <li>
                        You have not had any complaints made against you by your
                        manager or families.
                      </li>
                    </ul>

                    <h5>Benefits</h5>
                    <p id="orange">
                      The Company currently offers health, dental, and vision
                      benefits through Gusto to all eligible full-time (regular
                      40+ hours) employees. If eligible, each employee will
                      receive notice via Gusto and be tasked with applying
                      through the Gusto platform.
                    </p>

                    <h5>Attendance Expectations & Policy</h5>
                    <p id="orange">
                      You are required to be at your shifts as scheduled.
                      Absences and tardiness interfere with the functioning of
                      your clients care and program. It is your responsibility
                      to immediately notify your Supervisor as well as your
                      client’s family of your absence and/or tardiness. If an
                      employee desires to leave work for any reason during the
                      workday, the employee must obtain the approval of his or
                      her supervisor prior to leaving. If the employee must
                      leave a shift for any reason not within their control,
                      they must notify their supervisor immediately as to why
                      that is occurring and determine a plan to make up that
                      time.
                    </p>
                    <p id="orange">
                      The Company may require a physician’s note for an excess
                      of two (2) consecutive work days and reserves the right to
                      require an employee to furnish a physician’s note for each
                      sick day following the use of three (3) sick days in a
                      calendar year.
                    </p>
                    <p id="orange">
                      It is your responsibility to maintain communication with
                      your Supervisor. Any unauthorized absence of two (2) or
                      more work days shall be considered an abandonment of
                      employment and a voluntary resignation. Excessive
                      absenteeism or tardiness may subject the employee to
                      disciplinary action, up to and including termination.
                    </p>

                    <h5>Severe Weather & Emergency Closings</h5>
                    <p id="orange">
                      In the event of an emergency closing of our office,
                      services will be allowed to continue unless told otherwise
                      by your supervisor. In the event of a natural disaster or
                      state of emergency, BHPs will be informed by their
                      supervisors or other members of management regarding the
                      continuation of services.
                    </p>
                    <p id="orange">
                      In the event that a child’s school is closed due to snow
                      or inclement weather, services are able to continue as
                      planned. However, you are not allowed to drive with the
                      child on a state-declared snow day. If you do not feel
                      safe driving during a state-declared snow day, that is
                      considered a reasonable cause to reschedule your shift and
                      you must communicate your intentions with the parents and
                      your PM. You must notify your supervisor of your
                      intentions during any school closing.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(5)}
                    index={5}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Workplace Professionalism and Company Representation
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(5)}>
                    <h5>Work Dress Code</h5>
                    <p id="orange">
                      Employees represent the Company whenever they come in
                      contact with the public, therefore the dress of staff
                      should be appropriate and suited to the job they are
                      performing. Employees should not wear large piercings or
                      earrings as they could be a safety concern and
                      inappropriate tattoos must be concealed at all times. If a
                      family member or any other contact complains about
                      inappropriate dress code of an employee, the Company will
                      investigate the claim and the employee could face
                      disciplinary action. Multiple offenses could result in
                      disciplinary action up to and including termination.
                    </p>

                    <h5>Smoke-Free Workplace</h5>
                    <p id="orange">
                      The Company has been declared a tobacco-free workplace and
                      tobacco is not permitted on agency grounds. Under no
                      circumstances should an employee smoke in the presence of
                      a client.
                    </p>

                    <h5>Drugs and Alcohol: Drug-Free Workplace</h5>
                    <p id="orange">
                      The Company is committed to providing a safe, productive
                      and drug-free workplace. We have a drug-free workplace
                      policy to ensure the safety of employees and the clients
                      we serve. Employees found violating this policy will be
                      subject to disciplinary action up to and including
                      termination. Any employee who has been convicted of a
                      drug-related or substance abuse charge will face
                      disciplinary action up to and including termination.
                    </p>

                    <h5>Workplace Violence</h5>
                    <p id="orange">
                      The Company is committed to providing a safe and secure
                      workplace free from physical violence, threats and
                      intimidation. Violence is a serious form of misconduct and
                      may result in disciplinary action up to and including
                      termination and/or other legal action.
                    </p>
                    <h5>Safety and Security</h5>
                    <p id="orange">
                      Any vehicle, locker, desk, office or containers that are
                      agency property as well as backpacks, briefcases, etc are
                      subject to inspection and search for cause by Company
                      management or their designated agents.
                    </p>

                    <h5>Workplace Visitors</h5>
                    <p id="orange">
                      Employees are not permitted to have friends or family from
                      visiting them while working as this would compromise the
                      confidentiality of our client. At no time should
                      employment duties be compromised to greet a visitor.
                    </p>

                    <h5>Conflicts of Interest</h5>
                    <p id="orange">
                      The Company recognizes that the employment of individuals
                      who have existing relationships with employees or clients
                      (relatives, friends, etc) in certain circumstances can
                      disrupt the Company’s operations. When the Company
                      determines these problems will be present, it will decline
                      to hire an individual to work in the same department or in
                      any capacity that inhibits professionalism.
                    </p>

                    <h5>Boundaries</h5>
                    <p id="orange">
                      Employees are required to maintain appropriate boundaries
                      with the families they are working with. These
                      requirements indicate a strict professional relationship.
                      Some prohibited actions include:
                    </p>
                    <ul id="blue">
                      <li>
                        Acknowledging and/or accepting any “friendship” on any
                        social media platform
                      </li>
                      <li>
                        Participating in any personal outing outside of
                        treatment parameters (birthday party, family outings,
                        personal shopping, etc)
                      </li>
                      <li>
                        Spending time with one another outside of work hours or
                        without the child present
                      </li>
                      <li>
                        Disclosure of personal matters not applicable to the
                        child
                      </li>
                      <li>
                        Completion of any personal errands not required for job
                        performance
                      </li>
                      <li>
                        Any romantic or personal relationship with an employee
                      </li>
                      <li>Any contact unrelated to treatment or service</li>
                    </ul>

                    <h5>Accepting and Giving Entertainment or Gifts</h5>
                    <p id="orange">
                      Employees are not to accept any gifts, gratuities or tips
                      from clients, client’s families or any vendors.
                      Solicitation from a client, client’s family or vendors are
                      not permitted.
                    </p>

                    <h5>Mileage Reimbursement</h5>
                    <p id="orange">
                      As of March 8th, 2021, there will no longer be an
                      automatic mileage bonus and any employee who wishes to be
                      reimbursed for mileage must track it individually.
                      Employees are eligible for mileage reimbursement for any
                      driving completed while clocked in. This mileage should be
                      recorded on the React Portal and will be reimbursed at a
                      rate of $0.56/mile driven. Each employee is eligible to
                      claim up to double the amount of hours worked daily. For
                      example, if an employee works 5 hours, they are eligible
                      to be reimbursed for up to 10 miles. Additional mileage
                      reimbursement for long-distance commutes must be reviewed
                      and approved by a supervisor on an as-needed basis.
                    </p>

                    <h5>Payroll Information</h5>
                    <p id="orange">
                      The Company maintains payroll records for each employee as
                      required by law. Payroll records are the property of the
                      Company and may not be removed from Company premises
                      without written authorization. Payroll files are
                      confidential so access to records is restricted. Employees
                      may review their own individual payroll records and/or
                      personnel files using Gusto payroll services.
                    </p>

                    <h5>Compensation Schedule</h5>
                    <p id="orange">
                      The Company will generally allocate pay on a bi-weekly
                      schedule. The Company has the right to establish daily
                      and/or weekly hours of work by groups of employees, and/or
                      individual employees and the hours to be worked, including
                      starting and quitting times.
                    </p>

                    <h5>Required Signatures</h5>
                    <p id="orange">
                      We are not authorized to bill for services that have not
                      been signed by a parent or legal guardian. It is the BHP’s
                      job responsibility to acquire parent/guardian initials or
                      signatures as required. Failure to acquire a parent or
                      legal guardian’s signature will result in delayed
                      compensation. Continued failure to acquire needed
                      signatures may result in discipline up to and including
                      termination. It is the responsibility of the BHP to
                      communicate to their supervisor if a parent or guardian is
                      unable or unwilling to sign their documentation.
                    </p>

                    <h5>Recording Time Worked</h5>
                    <p id="orange">
                      It is the Company’s policy to record, review and pay the
                      hours worked by employees accurately in compliance with
                      the state’s legal obligations. Staff are strictly
                      prohibited from knowingly or intentionally:
                    </p>
                    <ol id="blue">
                      <li>Submitting false time records</li>
                      <li>Allowing anyone else to record their hours worked</li>
                      <li>
                        Recording hours worked on behalf of another employee
                      </li>
                    </ol>
                    <p id="orange">
                      Time records cannot be accept if not approved by family
                      and employee signatures. Payroll processors are prohibited
                      from knowingly or intentionally approving false time
                      records. Employees found violating this policy will be
                      subject to disciplinary action up to and including
                      termination.
                    </p>

                    <h5>Workers' Compensation</h5>
                    <p id="orange">
                      The Company provides Workers Compensation Insurance to
                      cover injuries sustained by employees while in the
                      performance of their work. Employees must immediately
                      report all work related injuries, however minor, to the
                      employee’s supervisor. Failure to timely report injuries
                      may result in the denial of workman’s compensation
                      benefits. The employee may not return to work unless
                      certified by a physician as being capable of carrying out
                      work responsibilities as outlined in his/her job
                      description.
                    </p>

                    <h5>Unemployment Compensation</h5>
                    <p id="orange">
                      The Company pays a state and federal tax to provide
                      employees with unemployment insurance in the event they
                      become unemployed through no fault of their own or due to
                      circumstances described by law. This insurance is
                      administered by state agencies who determine eligibility
                      for benefits.
                    </p>

                    <h5>Expense Reimbursement</h5>
                    <p id="orange">
                      Expense reimbursement is a method for paying employees
                      back when they spend their own money on business-related
                      expenses. These expenses include travel, hospitality and
                      business related purchases. The Company’s reimbursements
                      plan follows the requirements of the IRS Code Section 62
                      on Accountable Plans.
                    </p>
                    <p id="orange">
                      Expense reimbursement is not intended for the routine
                      purchase of office supplies or other business-related
                      expenses. Transactions must first be approved by the CEO
                      or COO in order to be reimbursed. Some transactions that
                      will not be reimbursed include those that are determined
                      to be of personal use or benefit, payment of independent
                      contractor services, payment of travel expenses for
                      individuals not employed by React, items or services not
                      given prior approval, or items that are restricted.
                    </p>
                    <p id="orange">
                      If an employee would like to request an expense
                      reimbursement, they should access the “Expenses” tab in
                      Gusto and submit a request. The requesting employee should
                      upload a receipt, a reason for submission, and the amount
                      requested. This request will be reviewed by React upper
                      management upon submission and either approved or denied.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(6)}
                    index={6}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Employee Time Off From Work
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(6)}>
                    <h5>Paid Holidays</h5>
                    <p id="orange">
                      Part Time employees are not required to work on Holidays,
                      but are eligible to earn “time and a half” pay, or 1.5
                      times their regular pay rate. If an employee is unable to
                      work that day, prior arrangements should be made with
                      their immediate Supervisor and client family members to
                      make up these hours later in the week. The Company
                      observes the following Holidays:
                    </p>
                    <ul id="blue">
                      <li>New Years Day</li>
                      <li>Martin Luther King, Jr. Day</li>
                      <li>Memorial Day</li>
                      <li>Independence Day</li>
                      <li>Juneteenth</li>
                      <li>Labor Day</li>
                      <li>Indigenous Peoples' Day</li>
                      <li>Veterans Day</li>
                      <li>Thanksgiving Day</li>
                      <li>Christmas Eve</li>
                      <li>Christmas Day</li>
                    </ul>
                    <p id="orange">
                      The Company also reserves one day per year for a “Floating
                      Holiday” to all employees. This day can be used as an
                      excused day off to celebrate any religious holiday.
                      However, this day is strictly an excused absence and is
                      not eligible for “time and a half” pay.
                    </p>
                    <h5>Paid Time Off (PTO)</h5>
                    <p id="orange">
                      It is the policy of the Company to provide regular part
                      and full-time employees with the opportunity to earn Paid
                      Time Off (PTO) from work. Employees are only eligible for
                      PTO if they are considered in good standing.
                    </p>
                    <p id="orange">
                      Effective January 1st, 2021, the state of Maine requires
                      all employers with 10 or more employees to provide 1 hour
                      of Paid Time Off per 40 hours worked. PTO will be capped
                      at 40 hours per 12 months of employment, beginning on the
                      date of hire. Employees are eligible to carry over up to
                      40 hours of unused time into the next 12-month period,
                      however no employee is eligible to use more than 40 PTO
                      hours in one period. PTO hours may be used for any
                      purpose, be that for personal, family, or medical reasons.
                      Employees are not eligible to receive PTO on days that
                      they are working.
                    </p>
                    <p id="orange">
                      If an employee quits, is terminated with cause, or is
                      released from the agency for any reason, any unused PTO
                      will not be distributed. If an employee is laid off due to
                      any reason out of the control of the Company, the Company
                      has the right to limit or restrict the payment of unused
                      PTO.
                    </p>

                    <h5>Vacation</h5>
                    <p id="orange">
                      All vacations must be requested and approved by the
                      employees immediate supervisor even if no PTO time is to
                      be utilized.
                    </p>
                    <h5>Sick Leave</h5>
                    <p id="orange">
                      The Company may require a physician’s note from an
                      employee in cases of absence in excess of two (2)
                      consecutive work days. A physician’s note may also be
                      required in cases where sick leave is being abused.
                    </p>

                    <h5>Attendance Policy</h5>
                    <p id="orange">
                      You are required to be at your shifts as scheduled.
                      Absences and tardiness interfere with the functioning of
                      your clients care and program. It is your responsibility
                      to immediately notify your Supervisor as well as your
                      client’s family of your absence and/or tardiness. If an
                      employee desires to leave work for any reason during the
                      workday, the employee must obtain the approval of his or
                      her supervisor prior to leaving.
                    </p>

                    <h5>Family and Medical Leave (FMLA)</h5>
                    <p id="orange">
                      The FMLA entitles eligible employees of covered employers
                      to take unpaid, job-protected leave for specified family
                      and medical reasons. Eligible employees are entitled to
                      twelve (12) weeks of family and medical leave during any
                      twelve (12) month period for the following reasons:
                    </p>
                    <ol id="blue">
                      <li>
                        The birth of the employee’s child and in order to care
                        for the child
                      </li>
                      <li>
                        The placement of a child with the employee for adoption
                        or foster care
                      </li>
                      <li>
                        To care for a spouse, child or parent of the employee
                        who has a serious health concern
                      </li>
                      <li>
                        A serious health condition which renders the employee
                        incapable of performing his/her job functions
                      </li>
                      <li>
                        An urgent need arising out of the fact that an
                        employee’s spouse, child or parent is called up for or
                        is on active duty in the Armed Forces in support of a
                        military contingency operation as defined by law and the
                        employee’s circumstances justify his/her need for leave
                      </li>
                    </ol>

                    <h5>Jury Duty</h5>
                    <p id="orange">
                      Any absence for jury duty or subpoena as a witness in a
                      court hearing, in which the employee is not the plaintiff,
                      defendant or a voluntary witness shall be excused. The
                      wages paid by the Company during such an absence shall be
                      the regular rate less the fee paid by the court for such
                      service for a period of up to one month.
                    </p>

                    <h5>Military Leave (USERRA)</h5>
                    <p id="orange">
                      The Company grants leaves of absence to serve active duty
                      in the Armed Forces of the United States without pay. Upon
                      completion of active service, the employee may return to
                      the agency with the same level of seniority, status, pay
                      and benefits.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(7)}
                    index={7}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Use of Company Equipment and Electronics
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(7)}>
                    <h5>Cell Phone & Telephone Use Policy</h5>
                    <p id="orange">
                      Employees are required to follow all confidentiality
                      requirements as agreed stated in the Employer and Employee
                      Confidentiality Statement. Employees own electronic media
                      may only be used during breaks. This includes but is not
                      limited to personal phone calls, browsing social media,
                      text messaging, etc. Employees who misuse cell phones or
                      telephones are subject to disciplinary action up to and
                      including termination.
                    </p>

                    <h5>Company Tools, Equipment, and Supplies</h5>
                    <p id="orange">
                      The Company uses various forms of electronic communication
                      including, but not limited to: computers, email,
                      telephones, voicemail, instant message, group messaging
                      services, text message, internet, cell phones,
                      smartphones, etc which are hereafter referred to as
                      “electronic communications”. The electronic
                      communications, including all software, databases,
                      hardware and digital files, remain the sole property of
                      the Company and are to be used only for Company business
                      and not for personal use.
                    </p>

                    <h5>Computer and Internet Use Policy</h5>
                    <p id="orange">
                      Electronic communications and media may not be used in any
                      manner that would be considered discriminatory, harassing,
                      obscene, or for any purpose that is illegal, against
                      Company policy or not in the best interest of the Company.
                      Employees who misuse electronic communications are subject
                      to discipline up to and including termination.
                    </p>

                    <h5>Blogging and Social Media Policy</h5>
                    <p id="orange">
                      Electronic communications and media may not be used in any
                      manner that would be considered discriminatory, harassing,
                      obscene, or for any purpose that is illegal, against
                      Company policy or not in the best interest of the Company.
                      Employees who misuse electronic communications are subject
                      to discipline up to and including termination.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(8)}
                    index={8}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Performance Expectations and Evaluation
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(8)}>
                    <h5>
                      Performance Development Planning and Feedback Process
                    </h5>
                    <p id="orange">
                      Written performance evaluations will be prepared for each
                      employee after six (6) months of employment and then on an
                      annual basis. If the employee has demonstrated the duties
                      of the position to be performed satisfactorily after three
                      (3) months, they will earn PTO time as well as come off
                      the initial probationary period.
                    </p>
                    <p id="orange">
                      Annual reviews are to document and maintain satisfactory
                      performance of all employees. Reviews are also a means of
                      measuring an employee’s effectiveness as well as
                      identifying areas where an employee is in need of training
                      or improving.
                    </p>

                    <h5>Employee Conduct and Performance</h5>
                    <p id="orange">
                      The Company has basic principles of integrity which serve
                      as guidelines regardless of job being fulfilled. The
                      Company expects its employees not to engage in any of the
                      following, including, but not limited to, activities which
                      may violate fraud, abuse, antitrust or environmental law.
                      The Company also deems the following conduct inappropriate
                      which may result in disciplinary action, up to and
                      including termination:
                    </p>
                    <ol id="blue">
                      <li>Dishonesty or falsification of Company records</li>
                      <li>
                        Unauthorized use or possession of Company property
                      </li>
                      <li>
                        Possession of illegal drugs, weapons or other dangerous
                        materials
                      </li>
                      <li>Fighting or engaging in threats of violence</li>
                      <li>
                        Use of abusive language or other disorderly conduct
                      </li>
                      <li>
                        Failure to perform assigned duties or comply with
                        Company policies
                      </li>
                    </ol>
                    <h5>Immediate Employment Termination</h5>
                    <p id="orange">
                      The Company is an at-will employer and may impose
                      discipline whenever it determines necessary or
                      appropriate. The Company may determine, at any time it is
                      appropriate, that an employee may be terminated
                      immediately.
                    </p>

                    <h5>Progressive Discipline</h5>
                    <p id="orange">
                      When an employee violates agency policy or procedures,
                      their supervisor is responsible for acting to correct the
                      situation. The Company operates under a "Progressive
                      Discipline" policy. When an employee violates agency or
                      state policies, fails to complete basic job functions, or
                      is in any way not performing at Company standards, their
                      immediate supervisor is responsible for documenting and
                      acting upon the situation. The progressive discipline is
                      as follows:
                    </p>
                    <ol id="blue">
                      <li>Verbal Warning</li>
                      <li>Written Warning</li>
                      <li>
                        Immediate performance review with upper management,
                        where employee is susceptible to probation, suspension,
                        decrease in hours, decrease in pay, and/or release from
                        client
                      </li>
                      <li>Termination</li>
                    </ol>

                    <h5>Complaint Procedure & Conflict Resolution</h5>
                    <p id="orange">
                      Employees are encouraged to speak with their supervisor
                      first. If the employee is not satisfied with the result or
                      feel they cannot approach their supervisor, they should be
                      presented to another member of Company management within
                      ten (10) day of the incident occurring. We will
                      investigate the complaint and if needed a meeting with the
                      parties involved with be made to discuss the issue.
                      Following the meeting, we will provide a written response
                      to all parties.
                    </p>

                    <h5>Employment Termination</h5>
                    <p id="orange">
                      Following the voluntary termination or resignation, all
                      employees who have given adequate notice will be paid for
                      their unused Paid Time Off (PTO) at a 50% rate of their
                      base pay based on the date of separation. Employees who
                      are involuntarily terminated will forfeit payment of any
                      unused and accrued PTO.
                    </p>

                    <h5>Exit Interviews</h5>
                    <p id="orange">
                      We offer optional Exit Interview in order to hear about
                      your experience working with us and how we may improve
                      going forward. Some of the questions we are interested in
                      are:
                    </p>
                    <ul id="blue">
                      <li>Why are you leaving?</li>
                      <li>
                        What did you like about your time here? What did you
                        dislike?
                      </li>
                      <li>What can we do to improve?</li>
                    </ul>

                    <h5>Return of Company Property</h5>
                    <p id="orange">
                      On the date of the employees termination for any reason,
                      or at any time prior at the Company’s request, the
                      employee shall return all property belonging to the
                      Company. This is includes, but is not limited to, any
                      Company provided laptops, computers, cell phones or
                      documents belonging to the Company.
                    </p>
                  </Accordion.Content>
                </Accordion>
              </Segment>
            </Segment.Group>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const EmployeeHandbook = (props) => {
  const { searchTerm } = useWikiSearch();
  const contentRef = useRef(null);
  useHighlightMatches(contentRef);

  return (
    <EmployeeHandbookClass
      {...props}
      searchTerm={searchTerm}
      contentRef={contentRef}
    />
  );
};

export default EmployeeHandbook;
